import { render, staticRenderFns } from "./iristarNews.vue?vue&type=template&id=9c74e11e&"
import script from "./iristarNews.vue?vue&type=script&lang=js&"
export * from "./iristarNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports